import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d93ebf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-field p-grid" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-2",
  for: "coordX"
}, "X", -1))
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-2",
  for: "coordY"
}, "Y", -1))
const _hoisted_7 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_8 = { class: "p-col" }
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_11 = { class: "p-col" }
const _hoisted_12 = { class: "p-col" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-field p-grid" }
const _hoisted_15 = {
  id: "map-container",
  class: "p-col",
  style: {"height":"550px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_location_picker_map = _resolveComponent("location-picker-map")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputNumber, {
            id: "coordX",
            modelValue: _ctx.x,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.x) = $event)),
            useGrouping: false,
            class: "p-mb-2",
            mode: "decimal",
            placeholder: "ex. 2'660'000 (LV95)"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputNumber, {
            id: "coordY",
            modelValue: _ctx.y,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.y) = $event)),
            useGrouping: false,
            class: "p-mb-2",
            mode: "decimal",
            placeholder: "ex. 1'345'000 (LV95)"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('map.municipality')) + ": ", 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("b", null, _toDisplayString(_ctx.municipality), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('map.height')) + ": ", 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("b", null, _toDisplayString(_ctx.height), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_location_picker_map, {
            x: _ctx.x,
            y: _ctx.y,
            onSelect: _ctx.setCoords
          }, null, 8, ["x", "y", "onSelect"])
        ])
      ])
    ])
  ], 64))
}